export type InterviewTimestampSource = {
  status?: string | null
  started_at?: string | null
  completed_at?: string | null
  created_at?: string | null
}

export type InterviewTimestampMeta = {
  label: 'Selesai' | 'Mulai' | 'Dibuat'
  value: string
  display: string
}

const formatter = new Intl.DateTimeFormat('id-ID', {
  day: '2-digit',
  month: 'short',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
})

export const formatInterviewTimestamp = (value?: string | null): string => {
  if (!value) return '-'
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return '-'
  return formatter.format(date)
}

export const resolveInterviewTimestampMeta = (
  interview?: InterviewTimestampSource | null
): InterviewTimestampMeta | null => {
  if (!interview) return null

  const status = String(interview.status || '').toLowerCase()

  if (status === 'completed') {
    if (interview.completed_at) {
      return { label: 'Selesai', value: interview.completed_at, display: formatInterviewTimestamp(interview.completed_at) }
    }
    if (interview.created_at) {
      return { label: 'Dibuat', value: interview.created_at, display: formatInterviewTimestamp(interview.created_at) }
    }
    return null
  }

  if (status === 'in_progress') {
    if (interview.started_at) {
      return { label: 'Mulai', value: interview.started_at, display: formatInterviewTimestamp(interview.started_at) }
    }
    if (interview.created_at) {
      return { label: 'Dibuat', value: interview.created_at, display: formatInterviewTimestamp(interview.created_at) }
    }
    return null
  }

  return null
}
